export default __webpack_public_path__ + "static/media/plus_circle.eb665316.svg";